import React from "react";
import classnames from "classnames";
import style from "./BottomBar.module.scss";

const BottomBar: React.FC = ({ children }) => {
  return (
    <div
      className={classnames(style.bottomBar, {
        [style.bottomBar__content]: children,
      })}
    >
      {children}
    </div>
  );
};

export default BottomBar;
